import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../stores';
import { Layers, Modals } from '../stores/layers';
import { Modal } from '../components/Modal';
import { useTranslateFunction } from '../helpers/useTranslationHook';

export const ConfirmDeleteModal = observer(() => {
  const { t } = useTranslateFunction(Layers.favourites);
  const { layers, favourites, myLocations } = useStore();

  return (
    <Modal
      icon="icon-trash"
      headline={t('Favoriten löschen')}
      content={t('confirm_delete_message')}
      className="no-scrollbar"
      abortAction={layers.closeModal}
      abortText={t('abort')}
      acceptText={t('button_delete_seletion')}
      acceptAction={() => {
        favourites.selected.forEach((poi) => {
          favourites.remove(poi);
        });
        favourites.deselectAll();
        layers.closeModal();
        favourites.setSelectable(false);
        myLocations.selected.forEach((poi) => {
          myLocations.remove(poi);
        });
        myLocations.deselectAll();
        layers.closeModal();
        myLocations.setSelectable(false);
      }}
      isOpen={layers.activeModal === Modals.confirmDelete}
    />
  );
});
